import { Label } from 'office-ui-fabric-react/lib/Label';
import { FC } from 'react';

import LogicAppImage from '../images/azLogicApps.png';
import { CostOutputTable } from './costoutputtable';
import { OutputInfoSection } from './outputinfosection';
import { Resources } from './resources';

export const CalculatorOutputContainer: FC<{}> = () => {
    return (
        <div className="calc-output">
            <Label className="calc-output-header">{Resources.OUTPUT_HEADER_LABEL}</Label>
            <div className="calc-output-content-container">
                <div className="calc-output-table-container">
                    <img alt="logicappslogo" className="calc-la-logo" src={LogicAppImage}></img>
                    <Label className="calc-output-label">{Resources.OUTPUT_TABLE_HEADER_LABEL}</Label>
                    <CostOutputTable />
                </div>
                <OutputInfoSection />
            </div>
        </div>
    );
}